export interface YoutubeMatchSubmitter {
  id: string;
  displayName: string | null;
  avatarUrl?: string | null;
}

export interface WorkYoutubeMatch {
  id: number;
  workId: string;
  youtubeVideoId: string;
  performerCredit: string;
  startMs: number;
  endMs?: number | null;
  notes?: string | null;
  createdAt: string;
  submitter: YoutubeMatchSubmitter;
  isMine: boolean;
}

export interface WorkYoutubeMatchCollectionResponse {
  matches: WorkYoutubeMatch[];
  total: number;
}

export interface CreateWorkYoutubeMatchPayload {
  youtubeUrl?: string;
  youtubeVideoId?: string;
  performerCredit: string;
  start?: string | number | null;
  end?: string | number | null;
  notes?: string | null;
}

export interface CreateWorkYoutubeMatchResponse {
  created: boolean;
  match: WorkYoutubeMatch;
}

export type YoutubeMatchStatus = 'idle' | 'loading' | 'loaded' | 'error';

const clamp = (value: number, min: number, max: number): number => {
  if (Number.isNaN(value)) return min;
  if (value < min) return min;
  if (value > max) return max;
  return value;
};

/**
 * Formats millisecond offsets into `H:MM:SS` or `M:SS` strings for display.
 */
export const formatYoutubeTimestamp = (milliseconds: number): string => {
  if (!Number.isFinite(milliseconds)) {
    return '0:00';
  }

  const totalSeconds = Math.floor(milliseconds / 1000);
  const clamped = clamp(totalSeconds, 0, Number.MAX_SAFE_INTEGER);

  const hours = Math.floor(clamped / 3600);
  const minutes = Math.floor((clamped % 3600) / 60);
  const seconds = clamped % 60;

  const paddedMinutes = hours > 0 ? minutes.toString().padStart(2, '0') : minutes.toString();
  const paddedSeconds = seconds.toString().padStart(2, '0');

  if (hours > 0) {
    return `${hours}:${paddedMinutes}:${paddedSeconds}`;
  }

  return `${minutes}:${paddedSeconds}`;
};
